import { styled } from "@mui/material"

import { palette } from "view/themes/palette"

export const Error = styled("div")(({ $align }) => ({
  marginTop: 7,
  color: palette.error500,
  fontSize: "14px",
  textAlign: $align,
}))
